import { render, staticRenderFns } from "./LacrosseCover_c2.vue?vue&type=template&id=4c906cd8&"
import script from "./LacrosseCover_c2.vue?vue&type=script&lang=js&"
export * from "./LacrosseCover_c2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports